module.exports = __webpack_public_path__ + "static/media/creditcard.c16b5b35.svg";